// extracted by mini-css-extract-plugin
export default {"main":"experienceserrors_main__U2FF1","header":"experienceserrors_header__QEhgO"};